import { render, staticRenderFns } from "./activityInstitutesManagment.html?vue&type=template&id=04bf31ad&scoped=true&external"
import script from "./activityInstitutesManagment.vue?vue&type=script&lang=js"
export * from "./activityInstitutesManagment.vue?vue&type=script&lang=js"
import style0 from "./activityInstitutesManagment.css?vue&type=style&index=0&id=04bf31ad&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf31ad",
  null
  
)

export default component.exports